module.exports = __webpack_public_path__ + "41ce8b8c4404c1e4ae0bb9deb4591c60.jpg";